import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { canAccessRoute, getDefaultDashboard } from '../config/roleConfig';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!canAccessRoute(user?.role, location.pathname)) {
    return <Navigate to={getDefaultDashboard(user?.role)} replace />;
  }

  return children;
};

export default ProtectedRoute;
